import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChart3"><Path d="M3.5 13.2773V20.4996H7.83V13.2773H3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.83002 8.83398V20.5007H14.16V8.83398H9.83002Z" stroke="currentColor" strokeLinecap="square"/><Path d="M16.17 3.5V20.5H20.5V3.5H16.17Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChart3;
